var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 32,
    viewBox: "0 0 141 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.758 0H56.942H50.0545H36.2385V6.92115H50.0545V31.9936H56.942V6.92115H70.758V0Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1781 6.93386H104.382V0H84.1781C77.8285 0 72.6621 5.18928 72.6621 11.5702V20.4234C72.6621 26.8012 77.8285 31.9936 84.1781 31.9936H104.382V25.0598H84.1781C81.6345 25.0598 79.5654 22.9815 79.5654 20.4266V19.4606H99.9177V12.5331H79.5654V11.567C79.5654 9.01212 81.6345 6.93386 84.1781 6.93386Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M140.654 32L121.342 15.5964L140.587 0.00317843H129.619L114.164 12.5235V0H107.273V31.9936H114.164V18.5613L129.986 32H140.654Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2915 0.00683594H7.92838V5.70137C7.92838 6.38459 8.47887 6.93434 9.15591 6.93434H23.0036C25.5504 6.93434 27.6163 9.00942 27.6163 11.5675V20.4207C27.6163 22.9788 25.5504 25.0539 23.0036 25.0539H6.90649V9.24775C6.90649 8.56453 6.356 8.01478 5.67896 8.01478H4.57764e-05V31.9909H23.0036C29.3659 31.9909 34.5228 26.8112 34.5228 20.4207V11.5675C34.5228 5.27556 29.5177 0.159368 23.2915 0.00683594Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0036 6.93434H9.15591C8.47571 6.93434 7.92838 6.38141 7.92838 5.70137V0.00683594H4.57764e-05V8.01478H5.6758C6.356 8.01478 6.90333 8.56771 6.90333 9.24775V25.0539H23.0036C25.5504 25.0539 27.6163 22.9788 27.6163 20.4207V11.5675C27.6163 9.00624 25.5504 6.93434 23.0036 6.93434Z",
    fill: "#FFE500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9a309c121841ed52d683040ef3f15a78.svg";
export { ForwardRef as ReactComponent };